import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-workspace",
  "use": "icon-workspace-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-workspace\">\n<rect x=\"5\" y=\"5\" width=\"14\" height=\"14\" rx=\"1\" stroke=\"currentColor\" stroke-width=\"2\" />\n<path d=\"M8.69531 16H10.3652L11.9473 10.3047H12.041L13.6406 16H15.2988L17.543 7.54492H15.7148L14.4082 13.5859H14.3145L12.7441 7.54492H11.25L9.70898 13.5859H9.61523L8.29688 7.54492H6.45703L8.69531 16Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol